module.exports = __webpack_public_path__ + "static/elephanty-welcome-32d906d8e8b69db96c43c5ce90908dd1.webp";